export enum FloorplanComponentStyle {
  Classic = 'classic',
  Version2 = 'version-2',
}
